

























































































































































































































































































import {
  defineComponent,
  onMounted,
  PropType,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api'
import { mdiPlus, mdiClose } from '@mdi/js'
import AButton from '../AButton/AButton.vue'
import AModal from '../AModal/AModal.vue'
import ADivider from '../ADivider'
import AIcon from '../AIcon'
import AStarRating from '../AStarRating'
import AProductReviewComment from '../AProductReviews/AProductReviewComment.vue'
import {
  IProductImage,
  HTMLInputEvent,
  PreviewImg,
} from './interfaces'
import { ReviewImage } from '@/interfaces/Product'
import * as customerApi from '@/api/customer'

export default defineComponent({
  name: 'ACustomerReviewForm',

  components: { AButton, AModal, ADivider, AIcon, AStarRating, AProductReviewComment },

  props: {
    id: {
        type: Number,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    image: {
        type: Object as PropType<IProductImage>,
    },
    customerName: {
        type: String,
    },
    avgRating: {
      type: Number,
    },
    trackingGoal: {
      type: Number,
    }
  },

  emits: ['modalClose', 'toggleMessage'],

  setup(props, { emit }) {
    const placeholder = ref('')
    const awaitResponse = ref(false)
    const fileInput = ref() as Ref<HTMLInputElement>
    const ratedProduct = ref(false)
    const localReview = ref({})
    const rStars = ref(0)
    const rAuthor = ref('')
    const rTitle = ref('')
    const rText = ref('')
    const rImages: ReviewImage[] = reactive([])
    const showErrorStars = ref(false)
    const showErrorAuthor = ref(false)
    const showErrorTitle = ref(false)
    const showErrorText = ref(false)
    const selectedFiles: Blob[] = reactive([])
    const previewImgs: PreviewImg[] = reactive([])
    const modal = reactive({
      show: true,
      maxWidth: 700,
      contentFullWidth: true,
    })

    function modalClose() {
        emit('modalClose', true)
    }

    function loadImage(e?: HTMLInputEvent) {
      try {
        if (!e) throw new Error('Event is null')
        if (!e.target.files) throw new Error('Files is null')

        let file: Blob = e.target.files[0]
        selectedFiles.push(file)

        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          let obj: PreviewImg = {
            title: '',
            content: '',
            url: '',
            picture: reader.result,
          }
          previewImgs.push(obj)
        }
      } catch (error) {
        console.error((error as Error).message)
      }
    }

    function removeImage(item: PreviewImg, index: number) {
      selectedFiles.splice(index, 1)
      previewImgs.splice(index, 1)
    }

    async function handleForm() {
      rStars.value > 0
        ? (showErrorStars.value = false)
        : (showErrorStars.value = true)
      rAuthor.value == '' || rAuthor.value.length < 3
        ? (showErrorAuthor.value = true)
        : (showErrorAuthor.value = false)
      rTitle.value == '' || rTitle.value.length < 3
        ? (showErrorTitle.value = true)
        : (showErrorTitle.value = false)
      rText.value == '' || rText.value.length < 10
        ? (showErrorText.value = true)
        : (showErrorText.value = false)

      if (showErrorStars.value || showErrorAuthor.value || showErrorTitle.value || showErrorText.value)
        return
      awaitResponse.value = true
      ratedProduct.value = true
      let images = []

      if (previewImgs.length > 0) {
        for (let index = 0; index < previewImgs.length; index++) {
          images[index] = {
            id: previewImgs[index],
            url: previewImgs[index].picture,
            description: props.title,
          }
        }
      }

      let date = new Date()

      localReview.value = {
        rating: (rStars.value - 15),
        author: rAuthor.value,
        createdAt: date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear() ,
        title: rTitle.value,
        text: rText.value.replace(/(?:\r\n|\r|\n)/g, '<br>'),
        images: images,
        comments: [],
        status: 2,
      }

      emit('saveReview', localReview.value)

      const fd = new FormData()
      fd.append('product_id', props.id.toString())
      fd.append('rating', rStars.value.toString())
      fd.append('nickname', rAuthor.value)
      fd.append('title', rTitle.value)
      fd.append('detail', rText.value)

      if (selectedFiles.length > 0) {
        selectedFiles.forEach((file, index) =>
          fd.append(index.toString(), file)
        )
      }

      try {
        const res = await customerApi.postReview(fd)
        console.log(res.status)
        emit('toggleMessage', res.status)
      } catch (error) {
        emit('toggleMessage', 404)
        console.log((error as Error).message)
      }

      modalClose()
      awaitResponse.value = false
    }

    onMounted(() => {
      if (props.customerName) rAuthor.value = props.customerName
      if (!props.customerName) placeholder.value = 'Veuillez indiquer votre nom'
    })

    return {
      placeholder,
      awaitResponse,
      fileInput,
      modal,
      ratedProduct,
      localReview,
      rStars,
      rAuthor,
      rTitle,
      rText,
      rImages,
      showErrorStars,
      showErrorAuthor,
      showErrorTitle,
      showErrorText,
      mdiPlus,
      mdiClose,
      selectedFiles,
      previewImgs,
      modalClose,
      loadImage,
      removeImage,
      handleForm,
    }
  },
})
